import { AuthService } from 'src/app/services/authentication/auth.service';
import { Injectable } from '@angular/core';
import { Notebook, TodoItemNode } from '../../model/notes.model';
import { LocalDatabaseService } from './local-database.service';
import { Firestore, onSnapshot, collection, doc, deleteDoc, updateDoc, addDoc, getFirestore} from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class NotebooksFirestoreService {

  private localDb: LocalDatabaseService;

  private firestore: Firestore = getFirestore();

  constructor(
    private authService: AuthService) { }

  setLocalDb(localDb: LocalDatabaseService) {
    this.localDb = localDb;
  }

  /**
   * Starts listening for changes in the notebooks collection for the current user.
   * When a change occurs (added, modified, or removed), it updates the local database accordingly.
   */
  startNotebooksListener() {
    const userId = this.authService.userId;
    const notebooksRef = collection(this.firestore, `users/${userId}/notebooks`);

    onSnapshot(notebooksRef, (snapshot) => {
      //console.log("startNotebooksListener - snapshot received ");

      snapshot.docChanges().forEach((change) => {
        const data = change.doc.data();
        const id = change.doc.id;

        //console.log("Notebook change received: ", change.doc.data(), change.doc.id, change.type);

        if (change.type === "added") {
          // New notebook added
          this.localDb.notebookAddAction({ id, ...data } as Notebook);
        }
        if (change.type === "modified") {
          // Notebook modified
          this.localDb.notebookModifiedAction({ id, ...data } as Notebook);
        }
        if (change.type === "removed") {
          // Notebook removed
          this.localDb.notebookRemovedAction({ id, ...data } as Notebook);
        }
      });
    }, (error) => {
      console.error("Error listening for notebook changes:", error);
    });
  }

  /**
   * Deletes a notebook from the database.
   *
   * @param notebook The notebook to be deleted.
   * @returns A promise that resolves to null if the deletion is successful.
   */
  deleteNotebook(notebook: TodoItemNode) {
    const notebookDocRef = doc(
      this.firestore,
      `users/${this.authService.userId}/notebooks/${notebook.id}`
    );

    return deleteDoc(notebookDocRef)
      .then(() => null)
      .catch((error) => {
        console.error('Opsss - error when deleting notebook:', error);
      });

    // melhorar aqui -- pq tem que apagar as imagens tmb
    // deixar no root um array com referencia a todas as imagens eu acho
    // ou no endereco da imagem - colocar o caderno pai com folder
    // dar o return aqui dai.
    // ao apagar note com imagem, apagar a imagem tmb
  }

  /**
   * Updates the name of a notebook in the database.
   *
   * @param notebook The notebook to be updated.
   */
  updateNotebookName(notebook: Notebook) {

    const notebookDocRef = doc(
      this.firestore,
      `users/${this.authService.userId}/notebooks/${notebook.id}`
    );

    return updateDoc(notebookDocRef, {
      text: notebook.text,
      lastChangeTime: new Date(),
    })
      .then(() => {
        // Update successful
      })
      .catch((error) => {
        console.error('Opsss - error when updating notebook:', error);
        throw error;
      });
  }

  updateNotebook(notebook: Partial<Notebook>) {
    // Save the notebook to the database
    notebook.lastChangeTime = new Date();

    const notebookDocRef = doc(
      this.firestore,
      `users/${this.authService.userId}/notebooks/${notebook.id}`
    );

    return updateDoc(notebookDocRef, notebook);
  }

  /**
   * Adds a new notebook to the database.
   *
   * @param name The name of the new notebook.
   */
  addNewNotebook(name: string) {


    const newNotebook: Notebook = {
      text: name,
      has_child: false,
      max_children_priority: 0,
      lastChangeTime: new Date(),
      createdAt: new Date()
    };

    const notebooksCollectionRef = collection(
      this.firestore,
      `users/${this.authService.userId}/notebooks`
    );

    addDoc(notebooksCollectionRef, newNotebook)
      .then(() => {
        // Notebook saved successfully
      })
      .catch((error) => {
        console.error('Opsss - error when saving notebook:', error);
      });
  }


}
